import {createReducer, on} from '@ngrx/store';
import {IGetRolesResponse} from "../../main/pages/users/roles/roles.service";
import {HttpActionState} from "../../main/pages/users/userslisting/store/users-listing.reducers";

import * as RolesActions from './../actions/roles.actions';


export interface IRolesState {
   templateRoles: {//TODO: in the first implementation some scope specific roles where implemented here. Consider refactor
       roles: []
   },
    fetchRolesListRequest: HttpActionState,
    roleList:IGetRolesResponse[]
}

const initialState: IRolesState = {
    templateRoles: { roles:[]},
    fetchRolesListRequest: HttpActionState.Init,
    roleList:[]
}

export const rolesReducer = createReducer(initialState,
    on(RolesActions.resetState, (state) => ({ ...state})),
    on(RolesActions.addTemplateRole, (state, {roles}) => ({
        ...state,
        templateRoles:{
            roles:roles
        }
    })),
    on(RolesActions.fetchRolesList, (state) => ({
        ...state,
        fetchRolesListRequest: HttpActionState.Busy,
    })),
    on(RolesActions.fetchRolesListSucceed, (state, {roles}) => ({
        ...state,
        roleList:roles,
        fetchRolesListRequest: HttpActionState.Done,
    })),
    on(RolesActions.fetchRolesListFailed, (state, ) => ({
        ...state,
        fetchRolesListRequest: HttpActionState.Failed,
    }))
)
